import { render, staticRenderFns } from "./EditLoginDetails.vue?vue&type=template&id=29a0b334"
import script from "./EditLoginDetails.vue?vue&type=script&lang=js"
export * from "./EditLoginDetails.vue?vue&type=script&lang=js"
import style0 from "./EditLoginDetails.vue?vue&type=style&index=0&id=29a0b334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports